import React from "react";
import Routes from "./AppRoutes";
import { ChakraProvider } from "@chakra-ui/react";
import "./App.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/bundle";

const App = () => {
  return (
    <div>
      <ChakraProvider>
        <Routes />
      </ChakraProvider>
    </div>
  );
};

export default App;
